/**
 * watchdog 百分比事件上报
 */

import watchdog from '@hll/watch-dog-jsutil';

const percentEventCache: any = {};

function createPercentEvent(eventName: string) {
  if (percentEventCache[eventName]) {
    return percentEventCache[eventName];
  }
  percentEventCache[eventName] = watchdog.createPercentEvent(eventName);

  return percentEventCache[eventName];
}

export function watchdogPercentEventSuccess(eventName: string, fields?: any) {
  try {
    const percentEvent = createPercentEvent(eventName);
    // console.log('>>> ~ watchdogPercentEventSuccess ~ percentEvent:', percentEvent, fields);

    if (fields) {
      percentEvent.addFields({ ...fields });
    }
    percentEvent.success();
  } catch (error) {
    console.log('百分比成功事件报错', error);
  }
}

export function watchdogPercentEventFail(eventName: string, fields?: any) {
  try {
    const percentEvent = createPercentEvent(eventName);
    if (fields) {
      percentEvent.addFields({ ...fields });
    }
    percentEvent.fail();
  } catch (error) {
    console.log('百分比失败事件报错', error);
  }
}
